
import { MapTo } from '@adobe/aem-react-editable-components';
import RewardsPoints, { RewardsPointsEditConfig } from './RewardsPoints';

export default MapTo('cob-corp-acquisition/components/creditonebank/rewards-points')(RewardsPoints, RewardsPointsEditConfig);
        